module.exports = __webpack_public_path__ + "2a9df3ca8f9dd145fcfe2e9f39d863c3.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/plant.jpg
 ** module id = 425
 ** module chunks = 0
 **/